<div class="tab-body" *ngIf="permissionData$| async as permissionData">
  <form [formGroup]="basicForm">
    <div class="form-inputs">
      <p class="paragraph-medium-regular">Requesting Officer*</p>
      <ng-select [items]="ROdropDown" bindLabel="value" appearance="outline" formControlName="RO" dropdownPosition="bottom"
        [readonly]="isReadOnly">
      </ng-select>
      <p class="assistive-text paragraph-small-regular">This staff represented in this application.</p>
    </div>

    <div class="form-inputs internal-radio">
      <div class="field-info">
        <p class="information-sensitivity paragraph-medium-regular">
          * Security classification level determines the level of Information
          sensitivity that may/may not have an impact on national
          security/interest.
        </p>

        <ng-template #tooltipTemplateSecurityClassification>
          <div class="custom-tooltip">
            <p>
              <strong>Official (Open)</strong>
              <br />
              Similar to Official (Closed), except information is disclosed to the public domain.
              <br />
              <br />
              <strong>Official (Closed)</strong>
              <br />
              Cause negligible or no impact to MINDEF/SAF functions, national interests or national security. [Note:
              However, such information is not disclosed to the public in the normal course of duty.]
              <br />
              <br />
              <strong>Restricted</strong>
              <br />
              Cause undesirable administrative ort security inconvenience to the administration of MINDEF/SAF.
              <br />
              <br />
              <strong>Confidential</strong>
              <br />
              Cause damage to national security or national interest, or security or interest of MINDEF/SAF.
              <br />
              <br />
              <strong>Secret</strong>
              <br />
              Cause serious damage to national security or national interest.
            </p>
          </div>
        </ng-template>

        <mat-icon class="custom-tooltip-help-icon" [tp]="tooltipTemplateSecurityClassification" tpMaxWidth="450px"
          [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
      </div>
      <p class="field-title paragraph-medium-regular">
        Select the <b>internal</b> security classification for this
        document. It determines how information can be shared
        <b>within the organisation.</b> <b>*</b>
      </p>
      <app-radio-options [control]="InternalControl" [options]="classification"
        [isReadOnly]="isReadOnly"></app-radio-options>
    </div>
    <div class="form-inputs external-radio">
      <p class="field-title paragraph-medium-regular">
        Select the <b> external </b>security classification for this
        document. It determines how information can be shared
        <b>outside the organisation.</b> <b>*</b>
      </p>
      <br/>
      <p class="field-title paragraph-medium-regular">
        All outgoing documents from DSO to vendors which are classified <b>"Restricted and above"</b>, 
        shall be recorded by Registry. The invited vendors must be cleared by MSD before DSO hand over the documents to them. 
      </p>
      <app-radio-options [control]="ExternalControl" [options]="classification" [condition]="internalValue"
        [filtering]="true" [isReadOnly]="isReadOnly">
      </app-radio-options>
    </div>
    <div class="form-inputs" *ngIf="purchaseType === 'permissiblecoveringpurchaseorder'">
      <p class="paragraph-medium-regular">Permissible reasons*</p>
      <ng-select [items]="permissibleReasondropDown" bindLabel="value" appearance="outline"
        formControlName="permissibleReason" [readonly]="isReadOnly">
      </ng-select>
    </div>
    <div class="form-inputs" *ngIf="this.genform.permissibleReason && this.genform.permissibleReason.id=='22'">
      <p class="paragraph-medium-regular">Please specify a reason</p>
      <input class="text-input" formControlName="otherPermissibleReasons" placeholder=" This field is required"
        [readonly]="isReadOnly">
    </div>
    <div class="form-inputs" *ngIf="purchaseType === 'tender' || purchaseType === 'dc'">
      <!-- <p> {{ purchaseType === 'dc' ? 'Type of requisition*' : 'Type of requisition' }}</p> -->
      <p class="paragraph-medium-regular">Type of requisition*</p>
      <ng-select [items]="typeOfRequisitiondropDown" bindLabel="value" appearance="outline"
        formControlName="typeOfRequisition" (change)="OnTypeOfRequisitionChange($event)"
        [readonly]="isReadOnly && !permissionData.ability.can('update', permissionData.formBasicInfo, AbilityField.Type_Of_Requisition)">
        <ng-template ng-option-tmp let-item="item">
          <div>
            <span style="float: left;">{{item.value}}</span>
            <span style="float: right;">
            <mat-icon [hidden]="!item.tooltip" class="custom-tooltip-help-icon" [tp]="item.tooltip"
              tpMaxWidth="450px" [tpInteractive]="true" tpPlacement="right">help</mat-icon>
            </span>
          </div>
        </ng-template>
      </ng-select>
      <div *ngIf="TypeOfRequisitionControl?.value?.id === 'PR9999'">
        <input class="text-input" formControlName="requisitionOthers"
          [readonly]="isReadOnly && !permissionData.ability.can('update', permissionData.formBasicInfo, AbilityField.Type_Of_Requisition)"
          placeholder="Please specify" />
      </div>
      <!-- <p><b>Contracting executive:</b> {{CE}}</p>
      <p><b>Tender document no:</b> {{TenderDocumentNo}}</p> -->
    </div>
    <div class="form-inputs" style="display: none;">
      <div class="field-info">
        <p class="paragraph-medium-regular">
          Do you wish to utilise any blanket purchase for this application?
        </p>
        <ng-template #tooltipTemplateApproved>
          <div class="custom-tooltip">
            <p>Approval of requirements (AOR) - These are documents with an approved
              set of budgets allocated to a specific set of items.
              <br />
              <br />
              Waiver of competition (WOC) - These are documents with an approved set
              of budgets allocated for purchase from a specific vendor.
              <br />
              <br />
              AOR + WOC - These are documents with an approved set of budgets
              allocated to set of items tied to a specific vendor.
            </p>
          </div>
        </ng-template>

        <mat-icon class="custom-tooltip-help-icon" [tp]="tooltipTemplateApproved" tpMaxWidth="300px"
          [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
      </div>
      <mat-button-toggle-group (change)="onPreapprovedValChange($event)" [isReadOnly]="true">
        <mat-button-toggle [value]="{id:1, value:'yes'}">Yes</mat-button-toggle>
        <mat-button-toggle [value]="{id:2, value:'no'}" checked>No</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="form-inputs" *ngIf="ApprovedControl.value['id'] == 1">
      <div class="field-info">
        <p class="paragraph-medium-regular">
          Select the blanket purchase type you wish to utilize.
        </p>
      </div>
      <mat-button-toggle-group (change)="onBlanketTypeValChange($event)" [isReadOnly]="isReadOnly">
        <mat-button-toggle [value]="{id:1, value:'any'}">Any</mat-button-toggle>
        <mat-button-toggle [value]="{id:2, value:'aor+woc'}">AOR + WOC</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="form-inputs" *ngIf="ApprovedControl.value['id'] == 1">
      <app-button class="test" icon="add" name="Add references" type="flat-button" tabindex="0"
        (keypress)="openBlanketPurchaseDialog(BlanketPurchaseTypeControl.value['value'])"
        (click)="openBlanketPurchaseDialog(BlanketPurchaseTypeControl.value['value'])"></app-button>
      <app-add-reference-card desc="You have not added any blanket purchase."
        *ngIf="blanketPurchaseDocumentArray.length==0" btnLabel="+ Add references"
        (btnClickHandler)="openBlanketPurchaseDialog(BlanketPurchaseTypeControl.value['value'])"></app-add-reference-card>
      <app-read-only-table *ngIf="blanketPurchaseDocumentArray.length>0" [data]="blanketPurchaseDocumentArray"
        [columns]="blanketPurchaseColumns"></app-read-only-table>
    </div>

    <div class="form-inputs" *ngIf="purchaseType.toLowerCase() === 'rfq'">
      <p class="paragraph-medium-regular">
        Select a pre-approved reason why system RFQ is not required
        <span class="required">* </span>
        <ng-template #tooltipTemplateReasonForNotUsingRFQ>
          <div class="custom-tooltip">
            <strong>Options</strong>
            <ul>
              <li *ngFor="let option of reasonForNotUsingRFQDropdown;">{{option?.Name}}</li>
            </ul>
          </div>
        </ng-template>
        <mat-icon class="custom-tooltip-help-icon" [tp]="tooltipTemplateReasonForNotUsingRFQ" tpMaxWidth="570px"
          [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
      </p>
      <ng-select class="internal-placeholder" [items]="reasonForNotUsingRFQDropdown" appearance="outline"
        bindLabel="Name" formControlName="reasonForNotUsingRFQ" [readonly]="isReadOnly" required
        placeholder="Please select an option">
      </ng-select>
    </div>


    <div class="form-inputs">
      <div class="field-info">
        <p class="paragraph-medium-regular">
          Do you have a Board-approved AOR document​ to this application?
        </p>
      </div>
      <mat-button-toggle-group (change)="onExcoBoardValChange($event)" [disabled]="isReadOnly">
        <mat-button-toggle [value]="{id:1, value:'yes'}"
          [checked]="ExcoBoardControl.value['id']==1">Yes</mat-button-toggle>
        <mat-button-toggle [value]="{id:2, value:'no'}"
          [checked]="ExcoBoardControl.value['id']==2">No</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="form-inputs" *ngIf="ExcoBoardControl.value['id'] == 1">
      <ng-container *ngIf="!isReadOnly">
        <div class="add-ref-button">
          <app-button class="test" icon="add" name="Add references" type="flat-button" tabindex="0"
            (keypress)="openExcoDialog()" (click)="openExcoDialog()"></app-button>
        </div>
      </ng-container>
      <ng-container *ngIf="excoBoardDocumentArray|filterDeleted as result">
        <app-add-reference-card *ngIf="result.length==0" desc="You have not added any approval documents."
          btnLabel="+ Add references" (btnClickHandler)="openExcoDialog()"></app-add-reference-card>
        <!-- <app-read-only-table *ngIf="result.length>0" [data]="result" [columns]="excoBoardColumns"></app-read-only-table> -->
        <div class="table-wrapper" *ngIf="result.length > 0">
          <table mat-table [dataSource]="result" class="mat-elevation-z8 data-grid-table">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="vSelect">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterVToggle() : null"
                  [checked]="rowSelection.hasValue() && isAllVSelected()"
                  [indeterminate]="rowSelection.hasValue() && !isAllVSelected()" *ngIf="!isReadOnly">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox tabindex="0" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()"
                  (change)="onCheckboxChange($event, row)" [checked]="rowSelection.isSelected(row)" *ngIf="!isReadOnly">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container *ngFor="let column of referenceColumns; let i = index">
              <ng-container [matColumnDef]="column.columnDef">
                <th mat-header-cell *matHeaderCellDef>
                  {{ column.header }}
                </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough }">
                  <div *ngIf="(isString(column.cell(row)))">{{column.cell(row)}}</div>
                  <div *ngIf="!(isString(column.cell(row)))">
                    <div [innerHTML]="(column.cell(row))"></div>
                  </div>
                </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="action" stickyEnd>
              <th mat-header-cell *matHeaderCellDef>
                Action
              </th>
              <td mat-cell *matCellDef="let row" class="d-flex flex-row action-icons">
                <ng-container
                  *ngIf="!isReadOnly || permissionData.ability.can('update', permissionData.formWoc, AbilityField.WOC_Vendor_Selection); else noEdit">
                  <div class="item-row-hover">
                    <a (click)="openDialog(row)">
                      <div class="row-button">
                        <mat-icon class="custom-icon" title="Discard">delete</mat-icon>
                      </div>
                    </a>
                  </div>
                </ng-container>
                <ng-template #noEdit>
                  <div class="item-row-hover">
                    <div class="row-button">
                      <mat-icon class="custom-icon disable-icon" title="Discard">delete</mat-icon>
                    </div>
                  </div>
                </ng-template>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="referenceDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: referenceDisplayedColumns"></tr>
          </table>
        </div>
        <mat-paginator #vendorPg [length]="result.length" showFirstLastButtons
          [pageSizeOptions]="pageSizeOptions"></mat-paginator>
      </ng-container>
    </div>
    <div class="form-inputs"
      *ngIf="!DocumentStatusToRemoveDIRP.includes(form.documentStatusId) && form.documentSubStatusId && !DocumentSubStatusToRemoveDIRP.includes(form.documentSubStatusId) && IsDIRPControl.value=== true">
      <div class="field-info">
        <p class="paragraph-medium-regular">
          Is this purchase for a non-R&D Information and Communication Technology (ICT) project with one-off development
          cost equals to, or more than S$1M?
          <ng-template #tooltipTemplateDIRP>
            <div class="custom-tooltip">
              <p>DSO ICT Resource Policy is applicable for DSO enterprise ICT capabilities and projects that are owned
                and
                funded by DSO, with development costs S$1M and above.
                <br /><br />Please seek the necessary approval and attach as supporting document if your purchase is
                applicable. If in doubt, please contact <a>{{this.digitalOfficeEmail}}</a>.
              </p>
            </div>
          </ng-template>

          <mat-icon class="custom-tooltip-help-icon" [tp]="tooltipTemplateDIRP" tpMaxWidth="300px"
            [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
        </p>
      </div>
      <mat-button-toggle-group (change)="onIsDIRPValChange($event)" [disabled]="isReadOnly">
        <mat-button-toggle [value]="true" [checked]="IsDIRPControl.value=== true">Yes</mat-button-toggle>
        <mat-button-toggle [value]="false" [checked]="IsDIRPControl.value===false">No</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="form-inputs" *ngIf="purchaseType === 'tender' || purchaseType === 'dc'">
      <p class="paragraph-medium-regular">Title of purchase*</p>
        <app-text-input [maxCharCount]="255"
        [control]="PurchaseTitleControl"
        [className]="className"
        [isReadOnly]="isReadOnly"></app-text-input>
    </div>
    <div class="form-inputs">
      <p class="paragraph-medium-regular">Purpose of purchase*</p>
      <app-text-input [maxCharCount]="1500" [control]="PurposeControl"
        placeHolderText="To include reason for purchase (Background, Impact if purchase not done, etc) and any other important information for AO's decision making."      
        [isReadOnly]="isReadOnly"></app-text-input>
    </div>
  </form>
</div>